"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataReportTypeToProviderMap = exports.DataReportType = void 0;
const dataReportProvider_1 = require("./dataReportProvider");
/** @TranslateToPython */
var DataReportType;
(function (DataReportType) {
    // Application related reports
    DataReportType["loanApplicationReport"] = "loanApplicationReport";
    DataReportType["applicantReport"] = "applicantReport";
    DataReportType["homeReport"] = "homeReport";
    DataReportType["homeSearchReport"] = "homeSearchReport";
    DataReportType["mailReport"] = "mailReport";
    DataReportType["manualOfferReport"] = "manualOfferReport";
    // Aven account data
    DataReportType["avenAccountDataReport"] = "avenAccountDataReport";
    // Credit reports
    DataReportType["experianSoftPullReport"] = "experianSoftPullReport";
    DataReportType["transUnionSoftPullReport"] = "transUnionSoftPullReport";
    DataReportType["equifaxSoftPullReport"] = "equifaxSoftPullReport";
    // experianHardPullReport = 'experianHardPullReport',   // Not used in UW.
    // Property reports
    DataReportType["houseCanaryLtv"] = "houseCanaryLtv";
    DataReportType["houseCanaryValueAnalysisReport"] = "houseCanaryValueAnalysisReport";
    DataReportType["coreLogicSubjectPropertyDetailReport"] = "coreLogicSubjectPropertyDetailReport";
    DataReportType["coreLogicTransactionHistoryReport"] = "coreLogicTransactionHistoryReport";
    DataReportType["coreLogicInvoluntaryLiensReport"] = "coreLogicInvoluntaryLiensReport";
    DataReportType["coreLogicTHVRiskManagementReport"] = "coreLogicTHVRiskManagementReport";
    DataReportType["clearCapitalAvmReport"] = "clearCapitalAvmReport";
    DataReportType["dataTreeProcisionPremierReport"] = "dataTreeProcisionPremierReport";
    DataReportType["dataTreeTotalViewReport"] = "dataTreeTotalViewReport";
    DataReportType["fidelityPropertyReport"] = "fidelityPropertyReport";
    DataReportType["usCensusBureauPropertyTaxReport"] = "usCensusBureauPropertyTaxReport";
    DataReportType["usCensusBureauAddressLookupReport"] = "usCensusBureauAddressLookupReport";
    // Income reports
    DataReportType["workNumberDataReport"] = "workNumberDataReport";
    DataReportType["plaidIncomeReport"] = "plaidIncomeReport";
    DataReportType["manualIncomeVerification"] = "manualIncomeVerification";
    DataReportType["ocrolusReport"] = "ocrolusReport";
    DataReportType["informedIQReport"] = "informedIQReport";
    DataReportType["irsReport"] = "irsReport";
    // trueworkReport = 'trueworkReport',
    // Attestation reports
    DataReportType["lienAttestationReport"] = "lienAttestationReport";
    DataReportType["manualLienInfoReport"] = "manualLienInfoReport";
    DataReportType["propertyValueAttestationReport"] = "propertyValueAttestationReport";
    DataReportType["propertyDetailsAttestationReport"] = "propertyDetailsAttestationReport";
    DataReportType["personalFinancialLiabilityBalance"] = "personalFinancialLiabilityBalance";
    // not used
    // houseCanaryAgileValueReport = 'houseCanaryAgileValueReport',
    // Special type: override.
    DataReportType["override"] = "override";
})(DataReportType || (exports.DataReportType = DataReportType = {}));
/**
 * Maps DataReportType to its corresponding DataReportProvider.
 * Only report types that have an external data provider are included.
 * Keys are DataReportType values (strings), values are DataReportProvider enum members.
 * @TranslateToPython
 */
exports.DataReportTypeToProviderMap = {
    // Application related reports
    [DataReportType.loanApplicationReport]: dataReportProvider_1.DataReportProvider.aven, // from Aven internal database
    [DataReportType.applicantReport]: dataReportProvider_1.DataReportProvider.aven, // from Aven internal database
    [DataReportType.homeReport]: dataReportProvider_1.DataReportProvider.aven, // from Aven internal database
    [DataReportType.homeSearchReport]: dataReportProvider_1.DataReportProvider.aven, // from Aven internal database
    [DataReportType.mailReport]: dataReportProvider_1.DataReportProvider.aven, // from Aven internal database
    [DataReportType.manualOfferReport]: dataReportProvider_1.DataReportProvider.aven, // from Aven internal database
    [DataReportType.avenAccountDataReport]: dataReportProvider_1.DataReportProvider.aven, // from Aven internal database
    // Special type: override.
    [DataReportType.override]: dataReportProvider_1.DataReportProvider.aven, // from Aven internal database
    // Credit reports
    [DataReportType.experianSoftPullReport]: dataReportProvider_1.DataReportProvider.experian,
    [DataReportType.transUnionSoftPullReport]: dataReportProvider_1.DataReportProvider.transUnion,
    [DataReportType.equifaxSoftPullReport]: dataReportProvider_1.DataReportProvider.equifax,
    // Property reports
    [DataReportType.houseCanaryLtv]: dataReportProvider_1.DataReportProvider.houseCanary,
    [DataReportType.houseCanaryValueAnalysisReport]: dataReportProvider_1.DataReportProvider.houseCanary,
    [DataReportType.coreLogicSubjectPropertyDetailReport]: dataReportProvider_1.DataReportProvider.coreLogic,
    [DataReportType.coreLogicTransactionHistoryReport]: dataReportProvider_1.DataReportProvider.coreLogic,
    [DataReportType.coreLogicInvoluntaryLiensReport]: dataReportProvider_1.DataReportProvider.coreLogic,
    [DataReportType.coreLogicTHVRiskManagementReport]: dataReportProvider_1.DataReportProvider.coreLogic,
    [DataReportType.clearCapitalAvmReport]: dataReportProvider_1.DataReportProvider.clearCapital,
    [DataReportType.dataTreeProcisionPremierReport]: dataReportProvider_1.DataReportProvider.dataTree,
    [DataReportType.dataTreeTotalViewReport]: dataReportProvider_1.DataReportProvider.dataTree,
    [DataReportType.fidelityPropertyReport]: dataReportProvider_1.DataReportProvider.fidelity,
    [DataReportType.usCensusBureauPropertyTaxReport]: dataReportProvider_1.DataReportProvider.usCensusBureau,
    [DataReportType.usCensusBureauAddressLookupReport]: dataReportProvider_1.DataReportProvider.usCensusBureau,
    // Income reports
    [DataReportType.workNumberDataReport]: dataReportProvider_1.DataReportProvider.workNumber,
    [DataReportType.plaidIncomeReport]: dataReportProvider_1.DataReportProvider.plaid,
    [DataReportType.manualIncomeVerification]: dataReportProvider_1.DataReportProvider.manualIncomeVerification,
    [DataReportType.ocrolusReport]: dataReportProvider_1.DataReportProvider.ocrolus,
    [DataReportType.informedIQReport]: dataReportProvider_1.DataReportProvider.informedIQ,
    [DataReportType.irsReport]: dataReportProvider_1.DataReportProvider.irs,
    // Liability reports
    [DataReportType.personalFinancialLiabilityBalance]: dataReportProvider_1.DataReportProvider.methodFi,
    // Attestation reports
    [DataReportType.lienAttestationReport]: dataReportProvider_1.DataReportProvider.attestation,
    [DataReportType.manualLienInfoReport]: dataReportProvider_1.DataReportProvider.attestation,
    [DataReportType.propertyValueAttestationReport]: dataReportProvider_1.DataReportProvider.attestation,
    [DataReportType.propertyDetailsAttestationReport]: dataReportProvider_1.DataReportProvider.attestation,
};
